'use strict'
import { createStore } from 'vuex'
import VuexReset from '@ianwalter/vuex-reset'
import pathify from './pathify'
import User from './modules/user'
import Logfile from './modules/logfile'
import ModulHandBuch from './modules/modulHandBuch'
import Modul from './modules/modul'
import Security from './modules/security'
import EventStoreApi from '../api/event-store'

const debug = process.env.NODE_ENV !== 'production',
    CLEAR_EVENTSTORE = 'CLEAR_EVENTSTORE',
    CLEAR_EVENTSTORE_ERROR = 'CLEAR_EVENTSTORE_ERROR'

const store = createStore({
    modules: {
        user: User,
        logfile: Logfile,
        modulHandBuch: ModulHandBuch,
        modul: Modul,
        security: Security
    },
    strict: debug,
    plugins: [VuexReset(), pathify.plugin],
    state: {
        isLoading: false,
        error: null
    },
    getters: {
        isLoading(state) {
            return state.isLoading
        },
        error(state) {
            return state.error
        }
    },
    mutations: {
        [CLEAR_EVENTSTORE](state) {
            state.error = null
        },
        [CLEAR_EVENTSTORE_ERROR](state, error) {
            state.error = error
        },
        // A no-op mutation must be added to serve as a trigger for a reset. The
        // name of the trigger mutation defaults to 'reset' but can be specified
        // in options, e.g. VuexReset({ trigger: 'data' }).
        reset: () => {}
    },
    actions: {
        async clearStore({ commit }) {
            commit(CLEAR_EVENTSTORE)
            try {
                let response = await EventStoreApi.clearAll()
                commit('user/CLEAR')

                return response
            } catch (errorResponse) {
                commit(CLEAR_EVENTSTORE_ERROR, 'Fehler beim Löschen des Stores')
                return errorResponse
            }
        }
    }
})

export default store

window.store = store
